import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DEVICE_SIZE } from '../../../../../core/models/others.model';
import { Quote } from '../../../../../core/models/quotes.model';
import { FormGroup, FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
import { ScreenViewModule } from '../../../../../core/directives/screen-view/_screen-view.module';
import { TableProComponent } from '../../../../../components/table-pro/table-pro.component';
import { TableProConfig } from '../../../../../components/table-pro/core/table-pro.model';
import { QuotesService } from '../../core/quotes.service';
import { take } from 'rxjs';
import { ExcelDownloadService } from '../../../../../core/services/excelDownload.service';
import { ExcelDownload } from '../../../../../core/models/excelDownload.model';
import { ToasterService } from '../../../../../components/toaster/toaster.service';

@Component({
  selector: 'quotes-history-table',
  standalone: true,
  imports: [CommonModule, FormsModule, I18nModule, ScreenViewModule, TableProComponent],
  templateUrl: './quotes-history-table.component.html',
  styleUrl: './quotes-history-table.component.scss',
})
export class QuotesHistoryTableComponent {
  @Input() form!: FormGroup;
  @Input() quotes?: Quote[] | undefined;
  DEVICE_SIZE = DEVICE_SIZE;

  tableConfig: TableProConfig = {
    collumnConfig: [
      { id: 'quoteNumber', index: 0, type: 'number' },
      { id: 'quoteName', index: 1, type: 'text' },
      { id: 'endCustomer', index: 2, type: 'text' },
      { id: 'location', index: 3, type: 'text' },
      { id: 'status', index: 4, type: 'text' },
      { id: 'approvalDate', index: 5, type: 'date' },
      { id: 'expirationDate', index: 6, type: 'date' },
    ],
  };

  constructor(
    private router: Router,
    private quotesService: QuotesService,
    private excelDownloadService: ExcelDownloadService,
    private toasterService: ToasterService,
  ) {}

  navigate(quoteId: string) {
    this.router.navigate(['/my-account/quotes-history'], { queryParams: { id: quoteId } });
  }

  exportQuotes() {
    const fromDate = this.form.get('fromDate')?.value;
    const formattedFromDate = fromDate ? new Date(fromDate).toISOString().split('T')[0] : '';

    const toDate = this.form.get('toDate')?.value;
    const formattedToDate = toDate ? new Date(toDate).toISOString().split('T')[0] : '';

    this.quotesService
      .exportToCSV(formattedFromDate, formattedToDate)
      .pipe(take(1))
      .subscribe(response => {
        if (response.hasError) {
          this.toasterService.displayError(response.message!);
          return;
        }

        if (response.obj) {
          const download: ExcelDownload = response.obj;
          this.excelDownloadService.downloadBase64File(download);
        }
      });
  }
}
